var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lennoc-search-select',{attrs:{"id":_vm.id,"label":"Land","disabled":_vm.disabled,"items":_vm.countries,"validationText":_vm.getUiString(['validatorMessages', 'nonumber'])},model:{value:(_vm.selectedCountry),callback:function ($$v) {_vm.selectedCountry=$$v},expression:"selectedCountry"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }